import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {v4 as uuidv4} from "uuid";

@Component({
    selector: 'iw-shop-dynamic-page-image-slider',
    standalone: false,
    templateUrl: './image-slider.component.html',
    styleUrls: ['./image-slider.component.scss']
})

export class ImageSliderComponent implements OnInit, AfterViewInit, OnDestroy {
    carouselId: string = '';

    @ViewChild('carousel', { read: ElementRef }) carouselRef!: ElementRef;

    @Input() item_class: string = '';
    _slider_show_indicators: boolean = true;
    @Input() set slider_show_indicators(slider_show_indicators: boolean | string) {
        if (typeof slider_show_indicators === 'string') {
            if(slider_show_indicators == 'true'){
                this._slider_show_indicators = true;

            } else if(slider_show_indicators == 'false'){
                this._slider_show_indicators = false;
            }

        } else {
            this._slider_show_indicators = slider_show_indicators || true;
        }
    }
    _slider_autoplay_interval: number = 3000;
    @Input() set slider_autoplay_interval(slider_autoplay_interval: number | string) {
        if (typeof slider_autoplay_interval === 'string') {
            const converted = Number(slider_autoplay_interval);
            if (!isNaN(converted)) {
                this._slider_autoplay_interval = converted;
            } else {
                // Handle invalid number string
                console.warn('Invalid number string provided for autoplay interval');
            }
        } else {
            this._slider_autoplay_interval = slider_autoplay_interval || 1;
        }
    }
    _slider_num_visible: number = 1;
    @Input() set slider_num_visible(slider_num_visible: number | string) {
        if (typeof slider_num_visible === 'string') {
            const converted = Number(slider_num_visible);
            if (!isNaN(converted)) {
                this._slider_num_visible = converted;
            } else {
                // Handle invalid number string
                console.warn('Invalid number string provided for autoplay interval');
            }
        } else {
            this._slider_num_visible = slider_num_visible || 1;
        }
    }
    _slider_num_scroll: number = 1;
    @Input() set slider_num_scroll(slider_num_scroll: number | string) {
        if (typeof slider_num_scroll === 'string') {
            const converted = Number(slider_num_scroll);
            if (!isNaN(converted)) {
                this._slider_num_scroll = converted;
            } else {
                // Handle invalid number string
                console.warn('Invalid number string provided for autoplay interval');
            }
        } else {
            this._slider_num_scroll = slider_num_scroll || 1;
        }
    }
    _slider_response_options_json: any[] | undefined;
    @Input() set slider_response_options_json(slider_response_options_json: any | string) {
        if (typeof slider_response_options_json === 'string') {
            try {
                this._slider_response_options_json = JSON.parse(slider_response_options_json);
            } catch (e) {
                console.log(e);
            }
        } else {
            this._slider_response_options_json = slider_response_options_json || [];
        }
    }
    @Input() set images_json(images_json: { path: string, alt?:string, url?: string }[] | string) {
        if (typeof images_json === 'string') {
            try {
                this.images = JSON.parse(images_json);
            } catch (e) {
                console.log(e);
            }
        } else {
            this.images = images_json || [];
        }
    }

    images: { path: string, alt?: string, url?: string }[] = [];


    constructor() {

    }


    ngOnInit() {
        this.carouselId = uuidv4();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.carouselRef) {
                const root: HTMLElement = this.carouselRef.nativeElement;

                const pButtons = Array.from(root.querySelectorAll('p-button')) as HTMLElement[];

                pButtons.forEach(wrapper => {
            /*        const inner = wrapper.querySelector('button'); // native button inside the wrapper
                    if (inner) {
                        // do something with inner button
                        inner.setAttribute('aria-label', 'Next Page');
                    }*/
                    wrapper.removeAttribute('aria-label');
                });


                // find all elements that are inside an ancestor with aria-hidden="true"
                const hiddenDescendants = root.querySelectorAll('[aria-hidden="true"] *');

                hiddenDescendants.forEach((el) => {
                    // only touch elements that are focusable or have tabindex attribute
                    const element = el as HTMLElement;
                    // optionally restrict to interactive selectors:
                    // if (!element.matches('button, a, input, select, textarea, [tabindex]')) return;

                    element.setAttribute('tabindex', '-1');
                    element.setAttribute('aria-hidden', 'true'); // keep in sync if needed
                });

                // also take care of the element that itself has aria-hidden="true" and is focusable
                const hiddenContainers = root.querySelectorAll('[aria-hidden="true"]');
                hiddenContainers.forEach((container) => {
                    const c = container as HTMLElement;
                    if (c.matches('button, a, input, select, textarea, [tabindex]')) {
                        c.setAttribute('tabindex', '-1');
                    }
                });
            }
        }, 500);
    }


    ngOnDestroy() {
    }

}
